import { render } from "./Shader.vue?vue&type=template&id=5f81d1ab&scoped=true"
import script from "./Shader.vue?vue&type=script&lang=js"
export * from "./Shader.vue?vue&type=script&lang=js"

import "./Shader.vue?vue&type=style&index=0&id=5f81d1ab&lang=scss&scoped=true"

import exportComponent from "C:\\__MRYNK\\_2022\\ynk-css-everydays\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f81d1ab"]])

export default __exports__